import type * as React from 'react';
import { post } from '@Domain/Api';
import type { AiModelPayload } from '@Application/Ai/AiConfiguration/Models/Actions/aiModelsFetched';
import aiModelCreated, {
	type AiModelCreatedAction,
} from '@Application/Ai/AiConfiguration/Models/Actions/aiModelCreated';
import aiModelCreationFailed, {
	type AiModelCreationFailedAction,
} from '@Application/Ai/AiConfiguration/Models/Actions/aiModelCreationFailed';
import type CreateAiModel from '@Application/Ai/AiConfiguration/Models/Commands/CreateAiModel';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = AiModelCreatedAction | AiModelCreationFailedAction;

export default (command: CreateAiModel) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<AiModelPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/ai-models`,
				command.toJSON(),
			);

			const action = aiModelCreated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiModelCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
